(() => {
  'use strict';

  const STORE_KEY = '__IYRS_FUNNEL_EVIDENCE_V1__';
  const LOG_PREFIX = '[IYRS Funnel Evidence V1]';
  const events = window[STORE_KEY] = Array.isArray(window[STORE_KEY]) ? window[STORE_KEY] : [];
  let pendingAdd = null;
  let subscriptionsReady = false;
  let lastSignature = '';
  let lastSignatureAt = 0;

  function currency() {
    return window.Shopify?.currency?.active || window.Shopify?.currency || 'USD';
  }

  function moneyValue(text) {
    const match = String(text || '').replace(/,/g, '').match(/(?:US)?\$\s*([0-9]+(?:\.[0-9]{1,2})?)/i);
    return match ? Number(match[1]) : null;
  }

  function parseSelectedVariant(productInfo) {
    if (!productInfo) return null;
    for (const script of productInfo.querySelectorAll('script[type="application/json"]')) {
      try {
        const value = JSON.parse(script.textContent || 'null');
        if (value && typeof value === 'object' && value.id && Number.isFinite(Number(value.price))) {
          return value;
        }
      } catch (_) {
        // Ignore unrelated JSON script blocks.
      }
    }
    return null;
  }

  function productContext(variantOverride) {
    const productInfo = document.querySelector('product-info[id^="MainProduct"], product-info[data-product-id]');
    const variant = variantOverride || parseSelectedVariant(productInfo);
    const priceText = productInfo?.querySelector('[id^="Price-"], .m-product-info--price')?.textContent || '';
    const cents = Number(variant?.price);
    return {
      product: document.querySelector('h1')?.textContent?.trim() || document.title.split('|')[0].trim(),
      product_id: productInfo?.getAttribute('data-product-id') || document.body.dataset.productId || '',
      variant_id: variant?.id ? String(variant.id) : '',
      selected_variant: variant?.public_title || variant?.title || '',
      value: Number.isFinite(cents) ? cents / 100 : moneyValue(priceText),
      currency: currency(),
    };
  }

  function record(eventName, detail = {}) {
    const timestamp = new Date().toISOString();
    const signature = `${eventName}:${detail.variant_id || ''}:${detail.selected_variant || ''}`;
    const now = Date.now();
    if (signature === lastSignature && now - lastSignatureAt < 500) return;
    lastSignature = signature;
    lastSignatureAt = now;

    const payload = { event_name: eventName, timestamp, ...detail };
    events.push(payload);
    if (events.length > 50) events.splice(0, events.length - 50);
    document.dispatchEvent(new CustomEvent('iyrs:funnel-evidence', { detail: payload }));
    console.info(LOG_PREFIX, JSON.stringify(payload));
  }

  function registerThemeSubscriptions() {
    if (subscriptionsReady) return true;
    if (!window.MinimogEvents?.subscribe || !window.MinimogTheme?.pubSubEvents) return false;
    subscriptionsReady = true;

    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (!variant) return;
      record('variant_select', productContext(variant));
    });

    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, (event) => {
      if (!pendingAdd || event?.cart?.errors) return;
      record('add_to_cart', {
        ...pendingAdd,
        cart_item_count: Number(event?.cart?.item_count) || null,
      });
      pendingAdd = null;
    });
    return true;
  }

  function initializeProduct() {
    const productInfo = document.querySelector('product-info[id^="MainProduct"], product-info[data-product-id]');
    if (!productInfo || productInfo.dataset.iyrsFunnelEvidence === 'true') return;
    productInfo.dataset.iyrsFunnelEvidence = 'true';
    record('view_item', productContext());

    productInfo.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', () => {
        pendingAdd = productContext();
      });
    });

    document.addEventListener('variant:changed', (event) => {
      if (event?.detail?.variant) record('variant_select', productContext(event.detail.variant));
    });
  }

  function initializeCart() {
    const checkout = document.querySelector('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!checkout || checkout.dataset.iyrsFunnelEvidence === 'true') return;
    checkout.dataset.iyrsFunnelEvidence = 'true';
    checkout.addEventListener('click', () => {
      const subtotalText = document.querySelector('.m-cart__subtotal, .m-cart--subtotal, [data-cart-subtotal], .totals__subtotal-value')?.textContent || '';
      const cartItems = [...document.querySelectorAll('.m-cart-item, [data-cart-item]')];
      const quantity = cartItems.reduce((total, item) => {
        const input = item.querySelector('input[name="updates[]"], .m-quantity__input');
        return total + (Number(input?.value) || 1);
      }, 0);
      record('begin_checkout', {
        cart_value: moneyValue(subtotalText),
        items: quantity || cartItems.length,
        currency: currency(),
      });
    }, { capture: true });
  }

  function initialize() {
    initializeProduct();
    initializeCart();
    if (registerThemeSubscriptions()) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (registerThemeSubscriptions() || attempts >= 20) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
